import { Component, inject } from '@angular/core';
import { RippleModule } from 'primeng/ripple';
import { TranslateModule } from '@ngx-translate/core';
import { SantanderSettingsService } from '../santander-settings.service';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-santander-setting',
  standalone: true,
  imports: [RippleModule, TranslateModule, ToggleSwitchModule, FormsModule],
  template: `
    <div class="settings-item" pRipple (click)="toggle()" (keydown.enter)="toggle()" role="button" tabindex="0">
      <div>
        {{ 'screens.santander.titles.integration' | translate }}
        <p>
          {{ 'screens.santander.labels.integration_description' | translate }}
        </p>
      </div>
      <div>
        <p-toggleswitch [ngModel]="state.santanderEnabled()" [readonly]="true" />
        <!--
        <i
          class="pi"
          [class.pi-check-square]="state.santanderEnabled()"
          [class.pi-stop]="!state.santanderEnabled()"
        ></i>
        -->
      </div>
    </div>
  `,
})
export class SantanderSettingComponent {
  protected readonly state = inject(SantanderSettingsService);

  toggle(): void {
    if (this.state.santanderEnabled()) {
      this.state.disableSantander();
    } else {
      this.state.enableSantander();
    }
  }
}
